// React, Next
import { useTranslation } from 'next-i18next'

// MUI
import Box from '@mui/material/Box'

// Custom
import Section from '@/components/sections/Section'
import SectionHeader from '@/components/sections/SectionHeader'
import BulletGrid from '@/components/sections/BulletGrid'

// Style
import themeColors from 'assets/theme/colors'

export default function WhyWorkWithUsSection() {
  const { t } = useTranslation('services')

  const items = [
    t('why.items.01'),
    t('why.items.02'),
    t('why.items.03'),
    t('why.items.04'),
    t('why.items.05'),
    t('why.items.06')
  ]

  const getContent = () => (
    <Box sx={{ width: '100%' }}>
      <SectionHeader
        eyebrow={t('why.eyebrow')}
        title={t('why.title')}
        intro={[t('why.intro1'), t('why.intro2'), t('why.intro3')]}
      />

      <BulletGrid items={items} columns={2} />
    </Box>
  )

  // *** MAIN RENDER ***
  return (
    <Section
      background={themeColors.kroemtech.background}
      paddingTop="5rem"
      paddingBottom="5rem"
      content={getContent()}
    />
  )
}
